export default {"src":"/_next/static/media/deck.f554350c.svg","height":111,"width":116,"blurWidth":0,"blurHeight":0};